import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
import { ResponseQ } from "../../../../common/dtos/paginate.dto";

export class GetGeneralLogsWithPaginationService {
  async run(params: any) {
    const response = await getByQuery<ResponseQ<any>>(`${services.logBooking}/getLogBooking`, params);
    return response;
  };
}

